import React, { SFC } from 'react';
import styled from 'styled-components';

import { Col } from 'antd';

interface CapturaHeaderDescriptionProps {
    term: string;
    span?: number;
}

const Description = styled.div`
    display: table;
`;

const Term = styled.div`
    display: table-cell;
    margin-right: 8px;
    padding-bottom: 12px;
    white-space: nowrap;
    line-height: 20px;

    :after {
        position: relative;
        top: -0.5px;
        margin: 0 8px 0 2px;
        content: ':';
    }
`;

const Detail = styled.div`
    display: table-cell;
    padding-bottom: 12px;
    width: 100%;
    line-height: 20px;
`;

export const CapturaHeaderDescription: SFC<CapturaHeaderDescriptionProps> = ({
    term,
    span = 12,
    children
}) => (
    <Col span={span}>
        <Description>
            <Term>{term}</Term>
            <Detail>{children}</Detail>
        </Description>
    </Col>
);
